// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_93444fe79c--tooltip--Hs2ji"};